import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getPROMOTIONSTableStructure";
export const UPDATE_TABLE_DATA = "updatePROMOTIONSTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setPROMOTIONSTableStructure";
export const SET_TABLE_DATA = "setPROMOTIONSTableData";
export const SET_TABLE_FILTER = "setPROMOTIONSTableFilter";
export const SET_TABLE_PAGE = "setPROMOTIONSTablePage";
export const SET_TABLE_PER_PAGE = "setPROMOTIONSTablePerPage";
export const SET_TABLE_SORT_BY = "setPROMOTIONSTableSortBy";
export const SET_NOT_VALID = "setPROMOTIONSNotValid";
export const SET_ACTION_NOT_VALID = "setPROMOTIONSAcitonNotValid";

const state = {
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  notValid: false,
  actionNotValid: true,
};

const getters = {
  getPROMOTIONSTableProperties(state) {
    return state.table_structure.properties;
  },
  getPROMOTIONSTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getPROMOTIONSTableState(state) {
    return state.table_state;
  },
  getPROMOTIONSTableHeaders(state) {
    return state.table_structure.columns;
  },

  getPROMOTIONSTableFilters(state) {
    return state.table_structure.filters;
  },

  getPROMOTIONSTableData(state) {
    return state.table_data.data;
  },

  getPROMOTIONSNotValid(state) {
    return state.notValid;
  },
  getPROMOTIONSAcitonNotValid(state) {
    return state.actionNotValid;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/promotion_rules")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/order_management/promotion_rules/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);
          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_NOT_VALID](state, value) {
    state.notValid = value;
  },
  [SET_ACTION_NOT_VALID](state, value) {
    state.actionNotValid = value;
  },
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },

  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PER_PAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORT_BY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
